






















import { defineComponent, PropType, computed } from '@vue/composition-api';
import { CallbackType } from '@/api/rights/types';
import { UserCreditData } from '@/pages/home/types';
import { ModuleConfig } from '@/pages/home/config/types';
import { PreCreditUserSourceEnums } from '@/enums/home-type';
import store from '@/store';
import { HaiXiaoQueryStatusType } from '@/api/homeV2Status/types';
import EquityRecallBar from '../../../components/EquityRecallBar/index.vue';
import BrandBar from '../../../components/BrandBar/index.vue';
import HaiXiaoBar from '../../../components/HaiXiaoBar/index.vue';
// import AdvWecomBanner from '@/components/adv-components/adv-wecom-banner';

export default defineComponent({
  name: 'FinanceCardTopBars',
  components: {
    EquityRecallBar,
    BrandBar,
    HaiXiaoBar,
    // AdvWecomBanner,
  },
  props: {
    /** 用户授信数据 */
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    /** 权益召回信息 */
    equityRecallInfo: {
      type: Object as PropType<CallbackType>,
      required: false,
    },
    /** 模块配置（企微等注释逻辑依赖） */
    moduleConfig: {
      type: Object as PropType<ModuleConfig>,
      required: false,
    },
    haiXiaoQueryData: {
      type: Object as PropType<HaiXiaoQueryStatusType>,
      required: true,
    },
  },
  setup(props) {
    /** 未授信：是否海消用户(海消用户、普通用户)
     * 已授信：showHaiXiaoBrand=true·
     */
    const isHaiXiaoUser = computed(() => {
      const { preCreditUserSource } = props.userCreditData;
      return (!!preCreditUserSource
        && [PreCreditUserSourceEnums.SEA_CONSUMER, PreCreditUserSourceEnums.NORMAL]
          .includes(preCreditUserSource))
        || props.haiXiaoQueryData?.showHaiXiaoBrand;
    });

    /** 是否显示权益召回入口 优先级：海消 > 权益召回，非海消且有权召时展示 */
    const showEquityRecallBar = computed(
      () => !isHaiXiaoUser.value
        && !!props.equityRecallInfo
        && props.equityRecallInfo.showPackageDetail === true,
    );

    /** 是否显示品牌信息 优先级：海消 > 权益召回 > 品牌，前两者都不展示时再展示品牌 */
    const showBrandBar = computed(
      () => !isHaiXiaoUser.value
        && !showEquityRecallBar.value
        && store.state.homeStore.showBrandingExp === true,
    );

    // /** 是否展示企微banner  权益召回优先级更高----企微入口先下掉 */
    // const showAdvWecomBanner = computed(
    //   () => !showEquityRecallBar.value && !props.moduleConfig?.advWecomBannerHidden,
    // );
    // /** 企微banner数据是否加载成功并显示 */
    // const hasAdvWecomBannerData = ref(false);
    // /** 处理企微banner数据加载成功的情况 */
    // const handleAdvWecomBannerLoad = () => {
    //   hasAdvWecomBannerData.value = true;
    // };
    // /** 处理企微banner数据为空的情况 */
    // const handleAdvWecomBannerNoData = () => {
    //   hasAdvWecomBannerData.value = false;
    // };

    return {
      isHaiXiaoUser,
      showEquityRecallBar,
      showBrandBar,
    };
  },
});
